/** Product identity for this SPA. */
export const APP_PRODUCT = process.env.REACT_APP_PRODUCT || 'gosuite';
export const PRODUCT_DISPLAY_NAME = process.env.REACT_APP_PRODUCT_DISPLAY_NAME || 'GoSuite';
export const PRODUCT_PARENT_NAME = 'GoBunnyy';
export const PEER_APP_URL = String(process.env.REACT_APP_PEER_APP_URL || '').replace(/\/$/, '');

export function peerAppHref(path = '/') {
  if (!PEER_APP_URL) return path;
  const suffix = path.startsWith('/') ? path : `/${path}`;
  return `${PEER_APP_URL}${suffix}`;
}
